import { Row } from 'antd'
import Text from 'antd/lib/typography/Text'
import { memo } from 'react'
import logo from '../../assets/images/Fingertip_logo.svg'
import moment from 'moment'

function Footer() {
  return (
    <div className="footer-container">
      <Row className="footer-content" justify="space-between" align="middle">
        <img src={logo} alt="logo" loading="lazy" />
        {process.env.REACT_APP_ENV_NAME == 'staging' && (
          <Text>Demo environment</Text>
        )}
        <p className="footer-text">
          &#169; {moment().format('YYYY')} Fingertip. All rights reserved.
        </p>
      </Row>
    </div>
  )
}

export default memo(Footer)
